import React, { useEffect, useState } from 'react';
import { Button, Modal, Form, Input, DatePicker, Descriptions, Space, Flex } from 'antd';
import CustomerPicker from "components/pickers/customer"
import InputNumber from "components/input-number"
import ImagePicker from "components/pickers/image/MultiImagePicker"
import DebtService from "services/debt"
import OrderService from "services/order"
import Info from "components/customer/Info"
import { useApp } from 'contexts/app';
import { EditOutlined, DeleteOutlined, UserDeleteOutlined, CreditCardOutlined } from "@ant-design/icons";
import { formatCurrency } from "utils/number"
import dayjs from 'dayjs';
import { useOrderDetailScreen } from "pages/order/Detail"
import { formatDate, formatOnlyDate } from "utils/date"
import PaymentDetail from "components/debt/PaymentDetail"

const service = new DebtService();
const orderService = new OrderService();
const AddDebt = ({ open, onClose }) => {



    const [showModal, setShowModal] = useState(false);
    const [showPayment, setShowPayment] = useState(false);
    const { order, loadData } = useOrderDetailScreen();
    const [paymentHistories, setPaymentHistories] = useState([])
    const [updateDebt, setUpdateDebt] = useState({})
    const { showLoading, prompt } = useApp();
    useEffect(() => {
        if (open) {
            setShowModal(true);
            loadHistories();
        }

    }, [open, order])



    const loadHistories = async () => {
        setPaymentHistories([])
        var lst = await orderService.getPaymentHistory(order.id);
        setPaymentHistories(lst);
    }


    const close = () => {
        setShowModal(false)
        onClose();
    }

    const showUpdateDebt = (debtId) => {
        setUpdateDebt({ isShow: true, id: debtId })
    }

    return (
        <>

            <Modal
                title="Thanh Toán"
                closable={{ 'aria-label': 'Custom Close Button' }}
                open={showModal}

                onCancel={close}
                footer={<Space>
                    <Button onClick={close}>Close</Button>
                    <Button type='primary' onClick={e => setShowPayment(true)}><CreditCardOutlined /> Nhận thanh toán</Button>
                </Space>}
            >
                <Space style={{ width: "100%" }} direction='vertical'>
                    <label>Chi tiết</label>

                    <table className='tbl_order' style={{ width: "100%" }}>

                        <colgroup>
                            <col style={{ width: 75 }}>
                            </col>
                        </colgroup>
                        <tr>
                            <td>Ngày</td>
                            <td>Nội dung</td>
                            <td >Số tiền</td>

                        </tr>
                        {paymentHistories.map(item => {
                            return (
                                <tr>
                                    <td style={{ width: 150 }}  >

                                        <Button type='link' onClick={e => showUpdateDebt(item.payment.id)}>
                                            {formatOnlyDate(item.payment.date)}
                                        </Button>


                                    </td>
                                    <td style={{ width: 150 }}  >{item.payment.description}</td>
                                    <td style={{ textAlign: "right", width: 150 }} >{formatCurrency(item.amount)}</td>

                                </tr>

                            )
                        })}


                        <tr>
                            <td colSpan={2}> Tổng tiền</td>
                            <td style={{ textAlign: "right" }}>      {formatCurrency(order.total_amount)}</td>
                        </tr>
                        <tr>
                            <td colSpan={2}>Đã thanh toán</td>
                            <td style={{ textAlign: "right" }}>      {formatCurrency(order.paid_amount)}</td>
                        </tr>
                        <tr>
                            <td colSpan={2}>Còn lại</td>
                            <td style={{ textAlign: "right" }}>      {formatCurrency(order.remain_amount)}</td>
                        </tr>

                    </table>

                    <table className='tbl_order' style={{ width: "100%" }}>

                    </table>



                    <Flex justify='flex-end'>

                    </Flex>

                </Space>

            </Modal>
            <Payment open={showPayment} onClose={e => setShowPayment(false)}></Payment>
            <PaymentDetail onSaved={e => { loadData(); loadHistories() }} open={updateDebt.isShow} id={updateDebt.id} onClose={open => setUpdateDebt({ ...updateDebt, isShow: false })}></PaymentDetail>


        </>
    );
};


const Payment = ({ open, onClose }) => {

    const [showModal, setShowModal] = useState(false);
    const [saving, setSaving] = useState(false);
    const { showLoading, prompt } = useApp();
    const { order, loadData } = useOrderDetailScreen();

    useEffect(() => {
        if (open) {
            form.setFieldsValue({ amount: order.remain_amount ?? order.total_amount, description: `Thanh toán đơn hàng ${order.id}`, date: dayjs(), id: order.id });
            setShowModal(true)
        }


    }, [open, order])




    const [form] = Form.useForm();
    const { showNotify } = useApp();

    const handleOk = () => {

        form.submit();
    };

    const onFinish = async (values) => {
        setSaving(true);
        await orderService.createPayment({ ...values });
        showNotify("Đã ghi nhận thanh toán");
        setSaving(false);
        loadData();
        close();
    }
    const close = () => {
        setShowModal(false)
        onClose();
    }
    return (
        <>

            <Modal
                title="Thanh Toán"
                closable={{ 'aria-label': 'Custom Close Button' }}
                open={showModal}
                onOk={handleOk}
                okButtonProps={{ loading: saving }}
                onCancel={close}
            >



                <Form
                    layout={"vertical"}
                    form={form}
                    onFinish={onFinish}

                >
                    <Form.Item name="id"
                        hidden
                    >

                    </Form.Item>


                    <Form.Item name="amount" label="Số tiền"
                        rules={[{
                            required: true,
                            message: "Bạn phải nhập số tiền"


                        }]}
                    >
                        <InputNumber />
                    </Form.Item>
                    <Form.Item name="description" label="Nội dung"
                        rules={[{
                            required: true,
                            message: "Bạn phải nhập nội dung"
                        }]}
                    >
                        <Input placeholder="Nội dung" />
                    </Form.Item>
                    <Form.Item name="date" label="Ngày thanh toán"
                        rules={[{
                            required: true,
                            message: "Bạn phải nhập nội dung"
                        }]}
                    >
                        <DatePicker placeholder="input placeholder" />
                    </Form.Item>


                    <Form.Item name="images" label="Hình ảnh"

                    >
                        <ImagePicker></ImagePicker>
                    </Form.Item>




                </Form>



            </Modal>
        </>
    );
};


export default AddDebt;